export default __webpack_public_path__ + "static/media/buy_nft_over.cb8ed999.png";